export default "__VITE_ASSET__MfRoNycW__"